import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getAllData = async (service_number, from, to, page,per_page) => {
  console.log(per_page,"per_page in API aaaaaaaaaaaaaa");
  
  try {
    let url = `/investors-ledger/investors-ledger?dum=a`;

    if (service_number) {
      url += `&service_number=${service_number}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};
